<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="common-hkyw-payment-box">
                    <h2>航空延误保障计划</h2>
                    <a href="javascript:;" class="applyPayment" @click="applyPay()"></a>
                </div>
                <img class="e-table" src="@/assets/images/common-hkyw-table@2x.png" alt="">
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>被保险人：世界白金鑫卡持卡人。</p>
                <p class="bold">细则2</p>
                <p>生效条件：所有保障均须在您激活世界白金鑫卡人民币卡后才可享有,同时您需使用本人世界白金鑫卡为本人支付(包括分期支付)公共交通工具100%票款或80%及以上的旅行费用,当次旅程方可获享以上保障。</p>
                <p class="bold">细则3</p>
                <p>生效日期：您的保险将在您激活后次月1日生效。</p>
                <p class="bold">细则4</p>
                <p>您可在发生延误后的30天(自然日)进行理赔,超过理赔期则保险公司不再受理。</p>
                <p class="bold">细则5</p>
                <p>如您对高额保障计划具体条款有疑惑,可拨打太平洋财险客户服务热线“95500”；理赔可直接拨打太平洋财险客户服务受理热线“4001110702”,或登陆http://srcb.p6air.com/。</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods:{
            applyPay(){
                window.location.href = 'http://srcb.p6air.com/'
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>